module.exports = __webpack_public_path__ + "static/media/cancel.18445307.svg";